import * as React from "react";
import { graphql } from "react-apollo";

import BOGraphQLLoader from "app/components/BOComponents/BOGraphQLLoader";
import withPagination, { PaginationProps } from "app/utils/withPagination";
import ConfigurableTable from "app/components/AppComponents/ConfigurableTable";
import fraudColumns from "./fraudColumns";
import { topMerchantsList } from "./TopMerchantsListQuery";

type Props = {
  name: string;
  from: string;
  to: string;
};

const withData = graphql<any, Props & PaginationProps>(topMerchantsList, {
  options: ({ from, to, pagination: { offset, limit } }) => ({
    fetchPolicy: "network-only",
    variables: {
      from,
      to,
      offset,
      limit,
    },
  }),
});

export default withPagination(
  withData((props) => (
    <BOGraphQLLoader data={props.data}>
      <ConfigurableTable
        columnConfigs={fraudColumns}
        defaultColumns={[
          "Name",
          "Limit category",
          "Transactions",
          "Volume",
          "Highest Tx",
          "Average Tx",
        ]}
        rows={(props.data.fraud && props.data.fraud.merchants_by_volume) || []}
        pagination={props.pagination}
        name={props.name}
      />
    </BOGraphQLLoader>
  ))
);
